import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'recordingWelcomeSurveyShown',
  'recordingWelcomeSurveyQuestionAnswered',
  'recordingWelcomeSurveyComplete',
  'recordingWelcomeSurveyDismiss',
] as const;

export const recordingSurveyEvents = getMappedEvents([...EVENTS], { shouldSendSubscriptionData: true });
